export enum ThemeTypes {
	Color = 'Color',
	Gradient = 'Gradient',
	Custom = 'Custom',
}
